/** Profile frame / outline cosmetics — keep ids in sync with aws-blocks ranked-ladder. */

export type FrameRarity = 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary';

export type ProfileFrameDef = {
  id: string;
  label: string;
  rarity: FrameRarity;
  accent: string;
  kind: 'tier' | 'placement';
};

export const PROFILE_FRAMES: ProfileFrameDef[] = [
  {
    id: 'frame-tier-gold',
    label: 'Gold Crest',
    rarity: 'uncommon',
    accent: '#d4a017',
    kind: 'tier',
  },
  {
    id: 'frame-tier-platinum',
    label: 'Platinum Crest',
    rarity: 'rare',
    accent: '#9ca3af',
    kind: 'tier',
  },
  {
    id: 'frame-tier-diamond',
    label: 'Diamond Crest',
    rarity: 'rare',
    accent: '#67e8f9',
    kind: 'tier',
  },
  {
    id: 'frame-tier-master',
    label: 'Master Crest',
    rarity: 'epic',
    accent: '#c084fc',
    kind: 'tier',
  },
  {
    id: 'frame-tier-blind_king',
    label: 'Blind King Crest',
    rarity: 'legendary',
    accent: '#fbbf24',
    kind: 'tier',
  },
  {
    id: 'frame-season-1-top1',
    label: 'Crownfall Champion',
    rarity: 'legendary',
    accent: '#f59e0b',
    kind: 'placement',
  },
  {
    id: 'frame-season-1-top3',
    label: 'Crownfall Podium',
    rarity: 'epic',
    accent: '#e879f9',
    kind: 'placement',
  },
  {
    id: 'frame-season-1-top10',
    label: 'Crownfall Top 10',
    rarity: 'rare',
    accent: '#38bdf8',
    kind: 'placement',
  },
  {
    id: 'frame-season-1-top50',
    label: 'Crownfall Contender',
    rarity: 'uncommon',
    accent: '#34d399',
    kind: 'placement',
  },
];

const BY_ID = new Map(PROFILE_FRAMES.map((f) => [f.id, f]));

export function getProfileFrameDef(
  frameId?: string | null
): ProfileFrameDef | undefined {
  if (!frameId) return undefined;
  return BY_ID.get(String(frameId));
}

export function tierLabel(tierId?: string | null): string {
  const map: Record<string, string> = {
    iron: 'Iron',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    diamond: 'Diamond',
    master: 'Master',
    blind_king: 'Blind King',
  };
  if (!tierId) return 'Unranked';
  return map[String(tierId)] ?? String(tierId);
}
